import { Fence } from './ReportSettings';
import { Point } from './doLinesIntersect';
import { Size } from 'types';

const defaultPointsAt320x240 = [
    { x: 110, y: 70 },
    { x: 210, y: 170 },
];

export const fencesToPoints = (fences: ReadonlyArray<Fence>, { width, height }: Size): Point[] => {
    if (!fences || !fences.length) {
        return defaultPointsAt320x240.map(({ x, y }) => ({
            x: Math.round(x * width / 320),
            y: Math.round(y * height / 240),
        }));
    }

    const firstPoint = {
        x: fences[0].x1,
        y: fences[0].y1,
    };
    return fences.reduce((points, { x2, y2 }) => [
        ...points,
        {
            x: x2,
            y: y2,
        },
    ], [ firstPoint ]);
};

export const pointsToFences = (points: ReadonlyArray<Point>): Fence[] => {
    if (!points || points.length < 2) {
        return [];
    }

    return points.slice(1).reduce((fences, { x, y }, i) => [
        ...fences,
        {
            x1: points[i].x,
            y1: points[i].y,
            x2: x,
            y2: y,
        },
    ], []);
};



// WEBPACK FOOTER //
// ./src/logic/reports/fencePoints.ts